module.exports = __webpack_public_path__ + "static/media/Klymit-Web-Destop-catelog.825b9223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Klymit/Klymit-Web-Destop-catelog.jpg
// module id = 596
// module chunks = 0